import { Component, Injector, Input, OnInit, forwardRef } from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NgForm,
} from '@angular/forms';
import { BaseProductFieldComponent } from '../base-product-component/base-product-field.component';
import { DropDownOption } from '@product/shared/models/GlobalInterfaces';
import { tap } from 'rxjs';
import { Translation } from '@app/shared/interfaces/Translation';
import { AttributeOption } from '@app/shared/interfaces/Attribute';
@Component({
  selector: 'app-product-field-select',
  templateUrl: './product-field-select.component.html',
  styleUrls: ['./product-field-select.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProductFieldSelectComponent),
      multi: true,
    },
  ],
})
export class ProductFieldSelectComponent
  extends BaseProductFieldComponent
  implements ControlValueAccessor
{

  @Input() enableCreateOption: boolean = false;
  languages: DropDownOption[] = [];
  addOptionDrawer: boolean = false;
  value: string | number | null = null;
  constructor(injector: Injector) {
    super(injector);
  }

  onChange: any = (value: string | number) => {};
  onTouched: any = () => {};
  writeValue(value: any): void {
    this.value = value;
    if (this.value === '-100') {
      this.addOptionDrawer = true;
      this.value = null;
    }
    this.onChange(this.value);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  override ngOnInit() {
    this.languages = this.dropDownsMetaData['languages'];
  }
 
  postOption(data: NgForm) {
    if (data.valid) {
      const value = data.value;
      const option: AttributeOption = {
        Name: value.name,
        Value: value.name,
        AttributeId: +this.field.Code,
        IsDefault: false,
        Id: 0,
        Translations: Object.keys(value)
          .filter((x) => !isNaN(+x) && value[x] != null && value[x] !== '')
          .map((langId) => {
            const translation: Translation = {
              Label: value[langId],
              LanguageId: +langId,
              ObjectType: 3,
              ObjectId: +this.controlName,
              ObjectField: 'Name',
            };
            return translation;
          }),
      };
      this.subscriptions.push(
        this.attributesService
          .postAttributeOption(option)
          .pipe(
            tap((newOpt: any) => {
              this.message.success('option added successfully.');
              this.dropDownsMetaData[this.field.Code].push({
                Code: newOpt.Id,
                Label: newOpt.Name,
              });
              this.value = newOpt.Id;
              this.addOptionDrawer = false;
              this.onChange(this.value);
            })
          )
          .subscribe()
      );
    } else if (data.errors != null) {
      const errs = data.errors;
      this.message.error('please check inputs and try again');
    }
  }
  languages2 = [{ Code: 1, Label: 'English' }, { Code: 2, Label: 'French' }];
  additionalFields: { value: string }[] = [];

  addFields(): void {
    for (let i = 0; i < 3; i++) {
      this.additionalFields.push({ value: '' });
    }
  }
 
}
